export * from './score-completion/score-completion.component'
export * from './score-copy-sentence/score-copy-sentence.component'
export * from './score-drawing/score-drawing.component'
export * from './score-enumeration/score-enumeration.component'
export * from './score-labeling/score-labeling.component'
export * from './score-multiple-choice/score-multiple-choice.component'
export * from './score-short-essay/score-short-essay.component'
export * from './score-single-choice/score-single-choice.component'
export * from './score-instruction/score-instruction.component'
